import { createSlice } from '@reduxjs/toolkit';
import { IAccount } from '../models/Account/IAccount';
import { IContactConfig } from '../models/Account/IContactConfig';
import { IContactEdit } from '../models/Account/IContactEdit';
import { LocationType, UserStatus } from '../models/enums';
import type { RootState } from './store';
import { IMembership } from '../models/Membership/IMembership';

interface AccountState {
  accountData: IAccount;
  contactConfigData: IContactConfig;
  contactEditData: IContactEdit;
  locationData: LocationType;
  membership: IMembership;
  userStatus: UserStatus;
}

const initialState: AccountState = {
  accountData: null,
  contactConfigData: null,
  contactEditData: null,
  locationData: LocationType.Global,
  membership: null,
  userStatus: UserStatus.Anonymous,
};

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setAccount: (state, action) => {
      state.accountData = action.payload;
    },
    setContactConfig: (state, action) => {
      state.contactConfigData = action.payload;
    },
    setContactEdit: (state, action) => {
      state.contactEditData = action.payload;
    },
    setLocation: (state, action) => {
      state.locationData = action.payload;
    },
    setMembership: (state, action) => {
      state.membership = action.payload;
    },
    setUserStatus: (state, action) => {
      state.userStatus = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setAccount,
  setContactConfig,
  setContactEdit,
  setLocation,
  setMembership,
  setUserStatus,
} = accountSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
export const selectAccount = (state: RootState) => state.accountReducer.accountData;
export const selectContactConfig = (state: RootState) => state.accountReducer.contactConfigData;
export const selectContactEdit = (state: RootState) => state.accountReducer.contactEditData;
export const selectLocation = (state: RootState) => state.accountReducer.contactEditData;
export const selectMembership = (state: RootState) => state.accountReducer.membership;
export const selectUserStatus = (state: RootState) => state.accountReducer.userStatus;

export default accountSlice.reducer;
